// extracted by mini-css-extract-plugin
export default {"container":"dynamicPageLoader__container__dP_35","component":"dynamicPageLoader__component__RFlGe","active":"dynamicPageLoader__active__VQEx9"};